import { Grid, Paper, Typography } from "@mui/material";
import type { TCancelDelivery } from "@schemas/DeliveryForm/CancelDeliverySchema";
import { DeliveryStatus } from "@types_def/models/delivery.types";
import { customDeliveryScheduledForDate } from "@utils/functions/Delivery";
import { useTranslation } from "react-i18next";

type Props = {
  status: DeliveryStatus;
  cancelledAt?: string | null;
  cancelReason?: TCancelDelivery;
};

export function CancellationCard({ status, cancelledAt, cancelReason }: Props) {
  const { t } = useTranslation();

  return (
    <Grid size={{ xs: 12 }}>
      <Paper
        elevation={4}
        sx={{ backgroundColor: "#E7E6F7", borderRadius: 1, padding: "20px", height: "100%" }}
      >
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <Typography textTransform="capitalize" variant="body1">
              <span style={{ fontWeight: 500, textTransform: "capitalize" }}>
                {t("common.shared.cancelled-by")}{" "}
              </span>
              :{" "}
              {status === DeliveryStatus.CANCELLED_BY_ADMIN
                ? t("common.shared.admin")
                : status === DeliveryStatus.CANCELLED_BY_MANDATORY
                  ? t("common.shared.mandatory")
                  : status === DeliveryStatus.CANCELLED_BY_CUSTOMER
                    ? t("common.shared.customer")
                    : t("common.shared.not-specified")}
            </Typography>
          </Grid>
          <Grid textAlign="right" size={{ xs: 6 }}>
            <Typography textTransform="capitalize" variant="body1">
              <span style={{ fontWeight: 500, textTransform: "capitalize" }}>
                {t("common.shared.cancelled-at")}{" "}
              </span>
              :{" "}
              {cancelledAt
                ? customDeliveryScheduledForDate(cancelledAt)
                : t("common.shared.not-specified")}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="body1">
              <span style={{ fontWeight: 500, textTransform: "capitalize" }}>
                {t("common.shared.reason")}{" "}
              </span>
              :{" "}
              {typeof cancelReason?.reason === "string"
                ? t(`delivery.cancelReason.${cancelReason.reason}`)
                : t("common.shared.not-specified")}
            </Typography>
            <Typography variant="body1">
              <span style={{ fontWeight: 500, textTransform: "capitalize" }}>
                {t("common.shared.additional-info")}{" "}
              </span>
              :{" "}
              {typeof cancelReason?.additionalInfo === "string" &&
              cancelReason.additionalInfo.length > 0
                ? cancelReason.additionalInfo
                : t("common.shared.not-specified")}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
